module.exports = __webpack_public_path__ + "img/weather50.669a827d.png";